(function () {
  //
  const footerData = [
    {
      title: "Features",
      data: [
        {
          title: "AI Agents",
          link: "https://shortvideo.ai/features/ai-agents/",
        },
        {
          title: "AI Templates",
          link: "https://shortvideo.ai/features/ai-templates/",
        },
        {
          title: "AI Editing",
          link: "https://shortvideo.ai/features/ai-editing/",
        },
      ],
    },
    {
      title: "Solutions",
      data: [
        {
          title: "Product Showcase",
          link: "https://shortvideo.ai/solutions/product-showcase/",
        },
        {
          title: "AI Video Ads",
          link: "https://shortvideo.ai/solutions/ai-video-ads/",
        },
        {
          title: "Viral Videos",
          link: "https://shortvideo.ai/solutions/viral-videos/",
        },
        {
          title: "E-Learning",
          link: "https://shortvideo.ai/solutions/e-learning/",
        },
      ],
    },
    {
      title: "Company",
      data: [
        {
          title: "About Us",
          link: "https://shortvideo.ai/about-us/",
        },
        {
          title: "Contact",
          link: "mailto:contact@shortvideo.ai",
        },
        {
          title: "Pricing",
          link: "https://shortvideo.ai/pricing/",
        },
      ],
    },
    {
      title: "Support",
      data: [
        {
          title: "FAQ",
          link: "https://shortvideo.ai/faq/",
        },
        {
          title: "Terms of Service",
          link: "https://shortvideo.ai/terms-of-service/",
        },
        {
          title: "Privacy Policy",
          link: "https://shortvideo.ai/privacy-policy/",
        },
      ],
    },
  ];
  const footerRightWrap = document.querySelector(".unique-wrap-right");
  // const footerTitles = document.getElementsByClassName('footer-title');
  // const footerLinks = document.getElementsByClassName('footer-link');
  footerData.forEach((item, index) => {
    let isFold = true;
    const divDom = document.createElement("div");
    const titleDom = document.createElement("div");
    const linkDom = document.createElement("div");

    const spanDom = document.createElement("span");
    spanDom.textContent = item.title;
    titleDom.appendChild(spanDom);

    // h5
    if (document.documentElement.clientWidth < 768) {
      const img = document.createElement("img");
      img.src =
        "https://vidfly-02.oss-us-east-1.aliyuncs.com/blog/images/downWhite.svg";
      titleDom.appendChild(img);
      titleDom.addEventListener("click", () => {
        if (isFold) {
          linkDom.classList.add("footer-link-active");
        } else {
          linkDom.classList.remove("footer-link-active");
        }
        isFold = !isFold;
      });
    }
    titleDom.classList.add("footer-title");
    linkDom.classList.add("footer-link");
    item.data.forEach((itm, idx) => {
      const a = document.createElement("a");
      a.textContent = itm.title;
      if (itm.link) {
        a.href = itm.link;
      } else {
        a.href = "#";
      }
      linkDom.appendChild(a);
      if (itm.hasUnderline) {
        a.style.textDecoration = "underline";
      }
    });
    divDom.appendChild(titleDom);
    divDom.appendChild(linkDom);
    footerRightWrap.appendChild(divDom);
  });
})();
